import megatron, { get } from '@stencil/megatron';
import axios from 'axios';
import {
  __GI_CB__,
  __SEAT_URL__,
  __EXTRA_SEAT_INFO_URL__,
  AIRLINE_INFO_URL,
  SUBMIT_URL,
  VALIDATE_FORM_URL,
  ZC_PRICE_INFO_URL,
  __INTERNAL_CHUNK_URL__,
  __CHUNK_URL__,
  __MWEB_TO_APP_CHUNK_URL__,
  __ADTECH_INFO_URL__,
  VALIDATE_FORM_V2_URL,
  SUBMIT_V2_URL,
  VALIDATE_SINGLE_TRAVELLER_URL,
  DELETE_TRAVELLER_URL,
  FLIGHT_AMEMITIES
} from '@stencil/flights-constants/src/urls';
import getCookieString from '@stencil/flights-utils/src/get-cookie-string';
import fetchGzipStream from '@stencil/fetch-gzip-stream';
import getCommonHeaders from '@stencil/flights-utils/src/get-common-headers';

// const pushToNewRelic = (newRelicObj: object) => {
//   sendToClientAnalytics({
//     apiName: 'thor_groundup_api',
//     serviceApp: 'aerial-mweb',
//     ...newRelicObj
//   });
// };
export async function getRepriceAddonsAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/reprice-addons/?`;
  let param = '';

  const paramObj = { v: 1.5, ...requestObj }; // default flavour and v if not provided
  Object.keys(paramObj).forEach(key => {
    if (param != '') {
      param += '&';
    }
    param += key + '=' + encodeURIComponent(paramObj[key]);
  });

  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'reprice addons get api',
    type: 'GET',
    headers,
    url: url + param,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function getBRPDetails(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/search/details/`;
  try {
    var headers = new Headers(getCommonHeaders());
    headers.append('x-pfm', window.flavour || '');
    headers.append('currency', 'inr');
    headers.append('locale', 'en-IN');

    const response = await megatron({
      name: 'BRP details',
      type: 'POST',
      headers,
      url: url,
      credentials: 'include',
      requestData: JSON.stringify(requestObj),
      pdtApiFailureError
    });
    if (response) {
      return response;
    }
  } catch (e) {
    console.log('e :', e);
  }
}

// export const getBRPTokenDetails = async (url, token, cookies, flavour = '') => {
export const getBRPTokenDetails = async (url, token, urlParams, cookies, flavour = '') => {
  try {
    const { rcoms, ...restUrlParams } = urlParams || {};
    const data = await axios.post(
      url,
      {
        ...(token && { t: token }),
        ...(rcoms && { id: JSON.parse(rcoms) }),
        ...restUrlParams
      },
      {
        headers: {
          Cookie: getCookieString(cookies),
          ...getCommonHeaders(),
          'x-pfm': flavour,
          currency: 'inr',
          locale: 'en-IN'
        }
      }
    );
    if (data && data.data) {
      return data.data;
    }
    return null;
  } catch (err_msg) {
    // pushToNewRelic({ err_msg, time: 0, url });
    return null;
  }
};

export async function getTxnIdDetailsAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/frl-flight-review/?`;
  let param = '';

  const paramObj = { v: 1.5, ...requestObj }; // default flavour and v if not provided
  Object.keys(paramObj).forEach(key => {
    if (param != '') {
      param += '&';
    }
    param += key + '=' + encodeURIComponent(paramObj[key]);
  });

  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'txn id details get api',
    type: 'GET',
    headers,
    url: url + param,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function postRepriceAddonsAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/reprice-addons/`;
  const paramObj = { v: 1.5, ...requestObj }; // default flavour and v if not provided

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');

  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'reprice addons api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function baggageDataAndFareRulesAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/common-farerules/`;
  const paramObj = { ...requestObj };
  // const paramObj = { ...requestObj, v: 1.5 };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'fare trends api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
    // requestData: param
  });
  if (response) {
    return response;
  }
}

export async function submitAPI(requestObj, queryParamsObj, pdtApiFailureError = err => {}) {
  const url = SUBMIT_URL;
  const paramObj = { ...requestObj };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }

  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const parameters = params.join('&');
  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'fare trends api',
    headers: header,
    type: 'POST',
    url: url + `?${queryParameters}`,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
    // requestData: param
  });
  if (response) {
    return response;
  }
}

export async function submitV2API(requestObj, queryParamsObj, pdtApiFailureError = err => {}) {
  const url = SUBMIT_V2_URL;

  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'submit v2 new',
    headers: header,
    type: 'POST',
    url: url + `?${queryParameters}`,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function getPriceAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/getprice/`;
  const paramObj = { v: 1.5, ...requestObj };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'fare trends api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }

  // TESTING FARE LOCK SOLD OUT FLOW
  // return {
  //   "refund": "success",
  //   "is_fare_lock_txn_id": true,
  //   "fare_lock_txn_id": 'GOFLDMTFRLB5AD5162383106',
  //   "error": "Flight Not Found"
  // }

  // TESTING FARE SURGE FLOW
  // return {
  //   "fare_predict":0,
  //   "farediff":0.0,
  //   "fare_breakup":[{
  //     "k":"Base Fare",
  //     "v":453,
  //     "bc":"",
  //     "fc":"",
  //     "sf":[{
  //       "k":"Adult Base Fare",
  //       "v":353,
  //       "bc":"",
  //       "fc":"",
  //       "sf":[]
  //     }]
  //   },{
  //     "k":"Fee & Surcharge",
  //     "v":809.0,
  //     "bc":"",
  //     "fc":"",
  //     "sf":[{
  //       "k":"Fuel Surcharge",
  //       "v":350
  //     },{
  //       "k":"User Development Fee",
  //       "v":81
  //     },{
  //       "k":"Passenger Handling Fee",
  //       "v":52
  //     },{
  //       "k":"Others",
  //       "v":326.0
  //     }]
  //   },{
  //     "k":"Fare surge, paid by Goibibo",
  //     "v":-100.0,
  //     "bc":"",
  //     "fc":"",
  //     "c":"#777777",
  //     "i":"https://gos3.ibcdn.com/surge2x-1606137140.png",
  //     "tt":"The price today, ( - ) the price you locked at.\n As promised, you only pay the lower amount, and the extra, is covered by Goibibo.",
  //     "pos":2,
  //     "sf":[]
  //   }],
  //   "version":"v2",
  //   "mmt":true,
  //   "repriced_fare":1262.0,
  //   "is_fare_lock_txn":true,
  //   "fare_diff_absorbed":100.0
  // }
}

export async function coTravellerDataAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/cotravellerdata/`;
  const paramObj = { ...requestObj };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'fare trends api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function getImpInfoAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${__GI_CB__}/v3/hulk/getimportantinfo?token=${requestObj.t}`;
  // const headers = {
  //   flavour: requestObj.flavour
  // };
  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'important info api',
    type: 'GET',
    url: url,
    headers,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function getExtraSeatsInfoAPI(pdtApiFailureError = err => {}) {
  const extraSeatUrl = __EXTRA_SEAT_INFO_URL__;

  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'extra seat info api',
    type: 'GET',
    headers,
    url: extraSeatUrl,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response && response.content) {
    const content = JSON.parse(response.content);
    return content;
  }
  return null;
}

export async function getAirlineInfoAPI(pdtApiFailureError = err => {}) {
  const airlineInfoUrl = AIRLINE_INFO_URL;

  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'airline info api',
    type: 'GET',
    headers,
    url: airlineInfoUrl,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response && response.content) {
    const content = JSON.parse(response.content);
    return content;
  }
  return null;
}

export async function getSpecialFareInfoAPI(flavour = 'PWA', pdtApiFailureError = err => {}) {
  const chunk =
    flavour === 'PWA' ? '?key=special_fares_info_app_v2' : '?key=special_fares_info_web_v2';
  // const chunk = flavour === 'PWA' ? '?key=special_fares_info' : '?key=special_fares_info_srp';
  const specialFareInfoUrl = `${__CHUNK_URL__}${chunk}`;

  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'special fare info api',
    type: 'GET',
    headers,
    url: specialFareInfoUrl,
    credentials: 'omit',
    pdtApiFailureError
  });
  if (response && response.content) {
    const content = JSON.parse(response.content);
    return content;
  }
  return null;
}

export async function validatFormAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = VALIDATE_FORM_URL;
  const paramObj = { ...requestObj };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'validate form api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
    // requestData: param
  });
  if (response) {
    return response;
  }
}

export async function validatFormAPIV2(requestObj, queryParamsObj, pdtApiFailureError = err => {}) {
  const url = VALIDATE_FORM_V2_URL;

  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json;charset=UTF-8');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'validate form v2 api',
    headers: header,
    type: 'POST',
    url: `${url}?${queryParameters}`,
    credentials: 'include',
    requestData: requestObj,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function validatSingleTravellerAPI(
  requestObj,
  queryParamsObj,
  pdtApiFailureError = err => {}
) {
  const url = VALIDATE_SINGLE_TRAVELLER_URL;

  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json;charset=UTF-8');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'validate single traveller api',
    headers: header,
    type: 'POST',
    url: `${url}?${queryParameters}`,
    credentials: 'include',
    requestData: requestObj,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function deleteTravellerAPI(
  requestObj,
  queryParamsObj,
  pdtApiFailureError = err => {}
) {
  const url = DELETE_TRAVELLER_URL;

  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json;charset=UTF-8');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'delete traveller api',
    headers: header,
    type: 'POST',
    url: `${url}?${queryParameters}`,
    credentials: 'include',
    requestData: requestObj,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function zcPriceAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = ZC_PRICE_INFO_URL;
  const paramObj = { ...requestObj };

  const params = [];
  for (const key in paramObj) {
    if (paramObj.hasOwnProperty(key)) {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(paramObj[key]));
    }
  }
  const parameters = params.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'zc price info api',
    headers: header,
    type: 'POST',
    url: url,
    credentials: 'include',
    requestData: parameters,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export async function getFareOptionsServer({
  flavour = '',
  pdtApiFailureError = err => {},
  locale = 'en-IN'
}) {
  const chunk =
    flavour === 'PWA' ? '?key=special_fares_info_app_v2' : '?key=special_fares_info_web_v2';
  const specialFareInfoUrl = `${__INTERNAL_CHUNK_URL__}${chunk}`;

  const response = await get(specialFareInfoUrl, {
    name: 'special fare info server api',
    headers: {
      'x-pfm': flavour || '',
      currency: 'inr',
      locale
    }
  });

  if (response?.data?.content) {
    const content = JSON.parse(response?.data?.content);
    return content;
  }

  return null;

  // const chunk = flavour === 'PWA' ? '?key=special_fares_info' : '?key=special_fares_info_srp';
  // const fareOptionsUrl = `${__INTERNAL_CHUNK_URL__}${chunk}`;
  // try {
  //   const response = await get(fareOptionsUrl, {
  //     name: 'fare_option_api',
  //     headers: { 'x-pfm': flavour, currency: 'inr', locale }
  //   });
  //   return response.data || null;
  // } catch (error_msg) {
  //   return null;
  // }
}

// export function pushPDTDataAPI(uuid, experimentDetails) {
//   fetch(PDT_URL, {
//     headers: {
//       'unique-id': uuid,
//       flavour: 'mobile'
//     },
//     credentials: 'include',
//     method: 'POST',
//     body: JSON.stringify(experimentDetails)
//   });
// }

export async function getSRPAdTechInfoAPI({ url, pdtApiFailureError = err => {} }) {
  var headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');

  const response = await megatron({
    name: 'adtech info api',
    type: 'GET',
    headers,
    url,
    credentials: 'include',
    pdtApiFailureError
  });
  if (response && response.content) {
    const content = JSON.parse(response.content);
    return content;
  }
  return null;
}

export async function getRepriseStreamData(requestBody) {
  const url = `${__GI_CB__}/review-stream`;

  const { onStream, onError, onClose, requestedBody } = requestBody;

  const headers = new Headers(getCommonHeaders());
  headers.append('x-pfm', window.flavour || '');
  headers.append('currency', 'inr');
  headers.append('locale', 'en-IN');
  headers.append('content-type', 'application/x-www-form-urlencoded');

  fetchGzipStream(url, {
    method: 'POST',
    headers: Object.fromEntries(headers),
    body: requestedBody,
    onClose: onClose,
    onStream: onStream,
    onError: onError
  });
}

export async function nudgeDynamicAPI(
  url,
  method,
  body = '',
  queryParamsObj = {},
  pdtApiFailureError = err => {}
) {
  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'CTA API',
    headers: header,
    type: method,
    url: url + `?${queryParameters}`,
    credentials: 'include',
    requestData: body,
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

function processChunkedResponse(response) {
  var text = '';
  var reader = response.body.getReader();
  var decoder = new TextDecoder();

  function readChunk() {
    return reader.read().then(appendChunks);
  }

  function appendChunks(result) {
    var chunk = decoder.decode(result.value || new Uint8Array(), { stream: !result.done });
    text += chunk;
    if (result.done) {
      return text;
    } else {
      return readChunk();
    }
  }

  return readChunk();
}

export function nudgeDynamicChunkedAPI(
  url,
  method,
  queryParamsObj = {},
  body = '',
  pdtApiFailureError = err => {},
  onLastChunk,
  onError
) {
  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  fetch(url + `?${queryParameters}`, {
    method,
    headers: Object.fromEntries(header),
    ...(method === 'POST' && { body })
  })
    .then(processChunkedResponse)
    .then(onLastChunk)
    .catch(onError);
}

export async function fetchFlightComparisonData(
  url,
  method,
  body = '',
  queryParamsObj = {},
  pdtApiFailureError = err => {}
) {
  const queryParams = [];
  for (const key in queryParamsObj) {
    if (queryParamsObj.hasOwnProperty(key)) {
      queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParamsObj[key]));
    }
  }

  const queryParameters = queryParams.join('&');
  var header = new Headers(getCommonHeaders());
  header.append('Content-Type', 'application/json; charset=UTF-8;');
  header.append('x-pfm', window.flavour || '');
  header.append('currency', 'inr');
  header.append('locale', 'en-IN');

  const response = await megatron({
    name: 'CTA API',
    headers: header,
    type: method,
    url: __GI_CB__ + url + `?${queryParameters}`,
    credentials: 'include',
    requestData: body,
    pdtApiFailureError
  });

  if (response) {
    return response;
  }
}
